import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input } from "sr/helpers";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";

type Props = {
  data: { bid_amount?: string };
  HandleDataProps: (payload: { bid_amount: string }) => void;
};

const BidAmountChange = forwardRef(({ data, HandleDataProps }: Props, ref) => {
  const [amount, setAmount] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const validationErrorHandle = useValidationErrorHandle();

  useEffect(() => {
    setAmount(data?.bid_amount || "");
  }, [data?.bid_amount]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      const raw = (amount ?? '').toString();
      if (!raw.trim()) { setErrorId('INPUT.VALIDATION.BID.AMOUNT'); return false; }
      const n = Number(raw.replace(/,/g, ''));
      if (!Number.isFinite(n)) { setErrorId('INPUT.VALIDATION.BID.AMOUNT.NUMBER'); return false; }
      if (n < 100) { setErrorId('INPUT.VALIDATION.BID.AMOUNT.MIN'); return false; }
      setErrorId('');
      return true;
    },
    submitForm: () => {
      const sanitized = amount.trim().replace(/[^0-9.]/g, '');
      const newData = { bid_amount: sanitized };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div>
      <p className="pt-4 text-base">Bid Amount</p>
      <Input
        name="bid_amount"
        value={amount}
        onChange={(e: any) => {
          const raw = String(e.target.value || '')
          const sanitized = raw.replace(/[^0-9.]/g, '')
          const parts = sanitized.split('.')
          const intPart = parts[0] || ''
          const decPart = parts[1] !== undefined ? parts[1].slice(0,2) : undefined
          const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          const formatted = decPart !== undefined ? `${withCommas}.${decPart}` : withCommas
          setAmount(formatted)
        }}
        placeholder="25000"
        prefix={<span className="text-gray-500">$</span>}
        error={errorId}
      />
    </div>
  );
});

export default BidAmountChange;
